"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MONTH_FORMAT_PATTERN_SHORT = exports.MONTH_FORMAT_PATTERN = exports.DAY_OF_WEEK_FORMAT_PATTERN = exports.DATE_MASK_PATTERN = exports.DATE_FORMAT_PATTERN = void 0;
var DATE_FORMAT_PATTERN = 'MM/dd/yyyy';
exports.DATE_FORMAT_PATTERN = DATE_FORMAT_PATTERN;
var MONTH_FORMAT_PATTERN = 'MMMM';
exports.MONTH_FORMAT_PATTERN = MONTH_FORMAT_PATTERN;
var MONTH_FORMAT_PATTERN_SHORT = 'MMM';
exports.MONTH_FORMAT_PATTERN_SHORT = MONTH_FORMAT_PATTERN_SHORT;
var DAY_OF_WEEK_FORMAT_PATTERN = 'dddd';
exports.DAY_OF_WEEK_FORMAT_PATTERN = DAY_OF_WEEK_FORMAT_PATTERN;
var DATE_MASK_PATTERN = 'MM/dd/yyyy';
exports.DATE_MASK_PATTERN = DATE_MASK_PATTERN;